import { SelectOption } from '@indigo-ag/component-module';
import { CreditException } from '@indigo-ag/schema';
import i18next from 'core/i18n';

const DEPRECATED_EXCEPTIONS: CreditException[] = [
  CreditException.CCV_WITH_TRADING_MANDATORY,
  CreditException.TRADING_EXCEPTION,
  CreditException.LAWSUITS_OR_SERASA
];

const TRANSLATIONS_MAP: { [key in CreditException]: string } = {
  FULL_LESSEE: i18next.t('fullLessee'),
  AVERAGE_PRODUCTIVITY_ADJUSTMENT: i18next.t('averageProductivityAdjustment'),
  COMMERCIAL_SKETCH: i18next.t('commercialSketch'),
  COMMITMENT_ABOVE_POLITICS: i18next.t('commitmentAbovePolitics'),
  EMBARGOES: i18next.t('embargoes'),
  OVERCOLLATERAL_REDUCTION: i18next.t('overcollateralReduction'),
  PLEDGE_DEGREE: i18next.t('pledgeDegree'),
  PRICE_ADJUSTMENT: i18next.t('priceAdjustment'),
  WAIVER_OF_CONSENT: i18next.t('waiverOfConsent'),
  EMBARGOED_AREAS: i18next.t('creditExceptions-embargoedAreas'),
  SERASA_RECORDS: i18next.t('creditExceptions-serasaRecords'),
  SERASA_INJUNCTION: i18next.t('creditExceptions-serasaInjunction'),
  LAWSUITS: i18next.t('creditExceptions-lawsuits'),
  OPEN_HARVEST_VALIDATION: i18next.t('creditExceptions-openHarvestValidation'),
  UNAPPROVED_TRADING_CREDIT: i18next.t('creditExceptions-unapprovedTradingCredit'),
  UNDELIVERED_CREDIT_ASSIGNMENT: i18next.t('creditExceptions-undeliveredCreditAssignment'),
  OUTDATED_REGISTRATION: i18next.t('creditExceptions-outdatedRegistration'),
  REGISTRATION_WITH_LAWSUITS: i18next.t('creditExceptions-registrationWithLawsuits'),
  IRREGULAR_CAR: i18next.t('creditExceptions-irregularCar'),
  OTHER: i18next.t('creditExceptions-other'),
  CCV_WITH_TRADING_MANDATORY: i18next.t('CCVWithTradingMandatory'),
  TRADING_EXCEPTION: i18next.t('tradingException'),
  LAWSUITS_OR_SERASA: i18next.t('lawsuitsOrSerasa')
};

export const creditExceptionsTranslations = TRANSLATIONS_MAP;

const creditExceptions: SelectOption<CreditException>[] = Object.keys(CreditException)
  .map(exception => ({
    name: TRANSLATIONS_MAP[exception as CreditException],
    value: exception as CreditException
  }))
  .filter(exception => !DEPRECATED_EXCEPTIONS.includes(exception.value));

export const creditExceptionsOptions: SelectOption<CreditException>[] = creditExceptions.sort((a, b) =>
  a.name.localeCompare(b.name)
);
